<template>
  <v-container>
    <h3 class="page-title">匯入篩檢報告</h3>
    <v-form ref="form">
      <v-card class="mt-8 pb-4">
        <v-card-title>{{ 年度 }} 年度篩檢報告</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              v-for="file in fileConfig.reportFiles"
              :key="file.key"
            >
              <v-file-input
                :ref="file.key"
                :accept="file.type"
                :label="`${file.label} (${file.type})`"
                outlined
                show-size
                dense
                hide-details
                clearable
                v-model="reportFiles[file.key]"
              >
              </v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            large
            class="px-12 mx-2"
            color="primary"
            @click="uploadReport()"
            >上傳</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>

    <v-dialog v-model="dialog" max-width="350px">
      <v-card>
        <v-card-title>匯入結果</v-card-title>
        <v-card-text>
          <div class="text-body-1" v-for="row in result">
            {{ row.type }}: 總共 {{ row.length }} 筆 / 匯入 {{ row.match }} 筆
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">關閉</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
const 年度 = dayjs().get("year") - 1911;

export default {
  name: "ImporReport",
  data: () => ({
    年度,
    result: null,
    dialog: false,
    reportFiles: {},
    fileConfig: {
      reportFiles: [
        {
          label: "當日活動名單",
          key: "當日活動名單",
          type: ".xls",
        },
        {
          label: "血液檢查報告",
          key: "血液檢查報告",
          type: ".xls",
        },
        {
          label: "FOBT報告",
          key: "FOBT報告",
          type: ".xls",
        },
        {
          label: "乳攝報告",
          key: "乳攝報告",
          type: ".xls",
        },
        {
          label: "X光報告",
          key: "X光報告",
          type: ".xlsx",
        },
      ],
    },
  }),
  created() {
    this.init();
  },
  methods: {
    init() {
      _.each(this.fileConfig.reportFiles, (config) => {
        this.reportFiles[config.key] = null;
      });
    },
    async uploadReport() {
      let formData = new FormData();
      _.each(this.reportFiles, (file, key) => {
        formData.append(key, file);
      });

      this.$vloading.show();

      setTimeout(async () => {
        try {
          this.result = (
            await this.axios.post("/dashboard/file", formData)
          ).data;
          this.dialog = true;
          this.$refs.form.reset();
        } catch (e) {
          alert(e);
        }

        this.$vloading.hide();
        this.init();
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped></style>
